import api from 'poly-eshop4/eshop/ui/js/container';

$(document)
  .off('submit.addCartPosition', '[data-add-cart-position]')
  .on('submit.addCartPosition', '[data-add-cart-position]', function(event) {
    event.preventDefault();
    const $wrapper = $(this).closest('[data-add-cart]');
    if ($wrapper) {
      let positionCount = $wrapper.attr('data-cart-item-position-count');
      positionCount = positionCount ? parseInt(positionCount, 10) : 0;
      const $reveal = $(`[data-add-to-cart-ask-reveal="${$wrapper.attr('data-cart-item')}"]`);
      const $reelsReveal = $(this).closest('[data-reels-reveal]');
      const $alternativesReveal = $(this).closest('[data-alternatives-reveal]');

      if (positionCount === 1 && $reveal.length) {
        const $overwritePosBtn = $reveal.find('[data-add-to-cart-overwrite-pos]');
        const $appendPosBtn = $reveal.find('[data-add-to-cart-append-pos]');
        $overwritePosBtn.on('click', () => {
          $overwritePosBtn.unbind('click');
          $appendPosBtn.unbind('click');
          api.addPosition($(this), 'cart', {
            behaviour: 'OVERWRITE_POS',
          }).then(() => {
            $reveal.foundation('close');
            if ($reelsReveal.length) {
              $reelsReveal.foundation('close');
            }
            if ($alternativesReveal.length) {
              $alternativesReveal.foundation('close');
            }
          });
        });
        $appendPosBtn.on('click', () => {
          $overwritePosBtn.unbind('click');
          $appendPosBtn.unbind('click');
          api.addPosition($(this), 'cart', {
            behaviour: 'APPEND_POS',
          }).then(() => {
            $reveal.foundation('close');
            if ($reelsReveal.length) {
              $reelsReveal.foundation('close');
            }
            if ($alternativesReveal.length) {
              $alternativesReveal.foundation('close');
            }
          });
        });
        $reveal.foundation('open');
      } else {
        api.addPosition($(this), 'cart').then(() => {
          if ($reelsReveal.length) {
            $reelsReveal.foundation('close');
          }
          if ($alternativesReveal.length) {
            $alternativesReveal.foundation('close');
          }
        });
      }
    } else {
      api.addPosition($(this), 'cart');
    }
  });

$(document).on('submit', '[data-add-cart-position-label]', function(event) {
  event.preventDefault();
  api.addPosition($(this), 'cart');
});

$(document).on('click', '[data-container-pdf-export]', function(event) {
  const reveal = $(`#${$(this).attr('data-open')}`);
  if (reveal.length) {
    event.preventDefault();
    reveal.attr('action', $(this).attr('href'));
  }
});

$(document).on('submit', '[data-container-pdf-export]', function(event) {
  event.preventDefault();
  window.open(`${$(this).prop('action')}&${$(this).serialize()}`);
  $(this).foundation('close');
});
